import React from "react";
import { Col, Image, Row, Layout } from "antd";
import { motion } from "framer-motion";

import "./Style.css";
import listMerit from "../../assets/achievement/1.png";

import IMG1 from "../../assets/achievement/1.svg";
import IMG2 from "../../assets/achievement/2.svg";
import IMG3 from "../../assets/achievement/3.svg";
import IMG4 from "../../assets/achievement/4.svg";
import IMG5 from "../../assets/achievement/5.svg";
import IMG6 from "../../assets/achievement/6.svg";
import IMG7 from "../../assets/achievement/7.svg";

const awards = [
  {
    title: "Gold Medal",
    sub: "GENIUS Olympiad (2024)",
    img: IMG2,
  },
  {
    title: "Gold Medal",
    sub: "International Science and Invention Fair (2022)",
    img: IMG3,
  },
  {
    title: "Gold Medal",
    sub: "International British Innovation, Invention, Technology Expo (2022)",
    img: IMG4,
  },
  {
    title: "Gold Medal",
    sub: "AI-JAM U.S Online (2023)",
    img: IMG5,
  },
  {
    title: "Bronze Medal",
    sub: "WorldInvent Singapore (2023)",
    img: IMG6,
  },
  {
    title: "Second Prize",
    sub: "Excellent Student Competition in Informatics (2022)",
    img: IMG7,
  },
];

const { Content } = Layout;

const AchievementsPage = () => {
  return (
    <>
      <div className="list-merit">
        <div className="marquee">
          <ul>
            <li>
              <img src={listMerit} alt="Image 1" />
            </li>
          </ul>
        </div>
      </div>

      <Layout>
        <Content
          style={{
            padding: "40px",
            maxWidth: "1400px",
            margin: "0 auto",
            overflow: "hidden",
          }}
        >
          <div className="achievement-content">
            <Row gutter={24} align="middle">
              <Col xs={24} md={12}>
                <img src={IMG1} alt="Image 1" className="img-fit" />
              </Col>
              <Col xs={24} md={12}>
                <Row gutter={[16, 16]}>
                  {awards.map((award, index) => (
                    <Col key={index} span={12}>
                      <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: index * 0.1 }}
                      >
                        <img
                          src={award.img}
                          alt={`Image ${index + 1}`}
                          className="img-fit"
                        />
                      </motion.div>
                    </Col>
                  ))}
                </Row>
              </Col>
            </Row>
          </div>
        </Content>
      </Layout>
    </>
  );
};

export default AchievementsPage;
